import { Link, Chip, Button, Card, CardHeader, CardBody, CardFooter, Tooltip } from '@heroui/react';

export const Apps = ({ applications }) => {
  applications = applications.filter(x => !!x.applicationUri);

  return (
    <div className="flex flex-col gap-4">
      {applications.map(x => (
        <Card key={x.name}>
          <CardHeader>
            <div className="flex items-center justify-between w-full">
              {x.name}
              <Tooltip
                content={
                  <Chip size="sm" color="primary">
                    {x.environment}
                  </Chip>
                }
              >
                <i className="ri-information-line" />
              </Tooltip>
            </div>
          </CardHeader>

          <CardBody className="flex flex-col gap-2 pt-0 items-center justify-center">
            {x.logoUri ? (
              <img
                width={'33%'}
                className="object-center object-contain shrink-0"
                src={x.logoUri}
              />
            ) : (
              <i className="ri-apps-line text-lg text-success" />
            )}
            <p className="italic text-sm">{x.description}</p>
          </CardBody>
          <CardFooter className="py-1 border-t justify-between">
            <Link href={x.applicationUri} showAnchorIcon className="text-xs">
              {x.applicationUri}
            </Link>
            <Tooltip content={`Open ${x.name}`} placement="right">
              <Button
                size="sm"
                isIconOnly
                variant="light"
                onPress={() => (window.location = x.applicationUri)}
                radius="full"
              >
                <i className="text-lg ri-arrow-right-double-line" />
              </Button>
            </Tooltip>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};
